<template>
  <div class="btn-back__wrapper">
    <button role="navigation" type="button" class="btn-back" @click="navigate">
      <div class="btn-back__icon">
        <vb-icon name="arrow_l" :size="18" :color="sass('info')" />
      </div>
      <div class="btn-back__text">
        <span>{{ resolved_text }}</span>
      </div>
    </button>

    <vb-modal
      v-if="forwards_only"
      :vb_options="{
        id: confirm_modal_id,
        title: 'Annulla prenotazione',
        ok_only: true,
        hide_footer: true,
        centered: true,
      }"
    >
      <p>Stiamo cancellando la tua selezione e dovrai ricominciare da capo.</p>
      <vb-button
        @click="confirm_cancel()"
        :vb_options="{
          text: 'Continua',
          variant: 'outline-info',
          block: true,
        }"
      />
    </vb-modal>
  </div>
</template>

<script>
export default {
  name: "btn-back",
  props: {
    text: String,
    path: {
      type: String,
      default: "",
    },
    // Kyte's bookFlight is one-shot: once /book has run, history.go(-1)
    // would land on an invalidated page. Replace the back walk with a
    // confirm modal that routes to /results.
    forwards_only: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolved_text() {
      if (this.text) return this.text;
      return "Torna indietro";
    },
    confirm_modal_id() {
      return `btn-back-confirm-${this._uid}`;
    },
  },
  methods: {
    navigate() {
      if (this.path) {
        this.$router.push(this.path);
        return;
      }
      if (this.forwards_only) {
        this.$bvModal.show(this.confirm_modal_id);
        return;
      }
      this.$router.go(-1);
    },
    confirm_cancel() {
      this.$store.commit("liveflight/trigger_search", true);
      this.$router.push("/results");
    },
  },
};
</script>

<style lang="scss">
.btn-back {
  margin-left: 0;
  color: var(--info);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: $font-size-base;
  font-weight: 400;
  line-height: 1;

  width: max-content;
  background: transparent;
  border: none;

  &:hover,
  &:hover * {
    text-decoration: none;
  }

  svg {
    height: 14px;
    margin-right: 8px;
    margin-left: -4px;
  }
}
</style>
